import '../app.es6';
import angular from 'angular';

const DirectiveName = 'sssResize';
class ResizeController {
  /* @ngInject */
  constructor ($scope, $element, SharedState, resize) {
    this.$scope = $scope;
    this.$elm = $element;
    this.sharedState = SharedState;

    ResizeController.$inject = ['$scope', '$element', 'SharedState', 'resize'];
  }

  init () {
    this.sharedState.initialize(this.$scope, this.$scope.name, {defaultValue: 0});
    this.$scope.$watch(() => {
      let style = window.getComputedStyle(this.$elm[0]);
      let ret = {
        w: this.$elm[0].clientWidth - parseInt(style.paddingLeft, 10) - parseInt(style.paddingRight, 10),
        h: this.$elm[0].clientHeight - parseInt(style.paddingTop, 10) - parseInt(style.paddingBottom, 10)
      };
      return ret;
    }, (newVal, oldVal) => {
      this.setGraphWidth(newVal.w);
    }, true);

    this.$elm.bind('resize', () => {
      this.$scope.$apply();
    });
  }

  setGraphWidth (width) {
    this.sharedState.set(this.$scope.name, width || 0);
  }
}

function link ($scope, $element, $attrs, controller) {
  controller.init();
}

function ddo () {
  return {
    restrict: 'A',
    controller: ResizeController,
    controllerAs: 'resizeController',
    require: DirectiveName,
    scope: {
      name: '@' + DirectiveName
    },
    link: link
  };
}

angular.module('myApp').directive(DirectiveName, ddo);



// WEBPACK FOOTER //
// ./app/components/sss-resize.es6